import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export type CorrectionType = 'FULL_DOCUMENT' | 'ITEM_LEVEL';

export interface CorrectionRequest {
  correctionType: CorrectionType;
  originalTransactionId: string;
  originalDocumentNumber: string;
  selectedItemIds?: string[];
  /** Per-asset correction quantities for partial corrections (assetId → qty) */
  selectedItemQuantities?: Record<string, number>;
  notes?: string;
}

export interface CorrectionResult {
  processedAt: string;
  correctionType: CorrectionType;
  correctedDocumentNumber: string;
  originalDocumentNumber: string;
  updatedAssetIds: string[];
  transactionId: string;
}

export class CorrectionService {
  async completeCorrection(request: CorrectionRequest): Promise<CorrectionResult> {
    const response = await httpClient.post<CorrectionResult>(
      API_CONFIG.ENDPOINTS.CORRECTION_COMPLETE,
      request,
    );
    return response;
  }
}

export const correctionService = new CorrectionService();
